export function notTranslated(text: string): string {
  return `TRANSLATE ${text}`;
}
